import { z } from "zod";

export const DTODesignSystemVersionStats = z.object({
  tokens: z.number(),
  designSystemComponents: z.number(),
  assets: z.number(),
  documentationPages: z.number(),
  figmaComponents: z.number(),
  stories: z.number(),
});

export const DTODesignSystemVersionStatsQuery = z.object({
  /**
   * Unique ID across versions (non-persistent ID)
   */
  brandId: z.string().optional(),
});

export type DTODesignSystemVersionStats = z.infer<typeof DTODesignSystemVersionStats>;
export type DTODesignSystemVersionStatsQuery = z.infer<typeof DTODesignSystemVersionStatsQuery>;
